module.exports = "/_next/static/images/495fbaf059b084f8b800068d0ad12d77-savings-without-logos-xs-2x.jpg.webp";